// @ts-check

/** @type {import("@liquidweb-dev/club-sauce/public/asset/index.raw").LWApiPublicAssetDetailsParamsRawI['alsowith']} */
const hostingDetailsAlsowith = [
	'productDisplayGroup',
	'nocworxRemoteDetails',
	'creation_date',
	'price',
	'privateParent',
	'featureDetails',
	'categories',
	'capabilities',
	'networkSummary',
	'children',
	'backupsAndStorage',
	'associationDetails',
	'resourceState',
	'diskDetails',
	'mesDetails',
	'powerStatus',
	'zone',
	'instance',
	'machine',
	'region',
	'template',
	'templateApp',
	'custom_description',
	'scheduledCancellationDate',
	'nextInvoiceDate',
];

export default hostingDetailsAlsowith;
